export const ExpenseModeEnum = {
    ClinicianReimbursement: 'clinician-reimbursement',
    CreditCard: 'cc',
    Payment: 'payment',
    Vault: 'vault',
    PendingCreditCard: 'pending-cc',
};
export default { ExpenseModeEnum };
